// src/components/Dashboard/MainSlider.js

import React from "react";
import { Box, Stack, Slider } from "@mui/material";
import Grid from "@mui/material/Grid";
import MainLabel from "./MainLabel";
import MainHeader from "./MainHeader";
import PropTypes from 'prop-types';

const MainSlider = ({ title, icon, value, onChange, min, max }) => {
  return (
    <div>
      {/* Dynamic Title Including Current Slider Value */}
      <MainHeader title={`${title} - ${value} km`} component={icon} />

      <Grid container spacing={1} alignItems="center">
        <Grid xs={12} sm={6} sx={{ width: "100%" }}>
          <Stack
            spacing={2}
            direction="row"
            sx={{ alignItems: "center", mb: 1, width: "100%" }}
          >
            <Box sx={{ width: "100%" }}>
              {/* Controlled Slider */}
              <Slider
                value={value}
                onChange={onChange}
                aria-label={title}
                valueLabelDisplay="auto"
                min={min}
                max={max}
                sx={{ width: "100%" }}
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>

      {/* Description */}
      <MainLabel
        variant="caption"
        content={`Adjust the distance between ${min} km and ${max} km.`}
      />
    </div>
  );
};

MainSlider.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
};

export default MainSlider;
